import {DataObject} from "./DataObject";
import {EcommerceConnection} from "./EcommerceConnection";
import {Product} from "./Product";

export class EcommerceProduct implements DataObject {
  ID: number;
  ecommerceconnection_ID: number;
  product_ID: number;
  remoteUpdateStatus: string;
  updateTimestamp: Date;
  releaseTimestamp: Date;
  terminationTimestamp: Date;
  remoteChangeType: string;
  remoteproduct_ID: string;
  remoteTitle: string;
  updateMessage: string;
  rawRemoteProduct: string;
  ecommerceConnection: EcommerceConnection;
  product: Product;
  ignoreStatus: string;
  remoteTimestamp: Date;
  productStatus: string;
  updateStatus: string;
  changeType: string;

  constructor( obj ) {
    if ( obj && obj['ID'] ) {
      this.ID = obj['ID'];
    }
    this.ecommerceconnection_ID = 0;
    this.product_ID = 0;
    this.remoteUpdateStatus = '';
    this.updateTimestamp = new Date(0);
    this.releaseTimestamp = new Date(0);
    this.terminationTimestamp = new Date(0);
    this.remoteChangeType = '';
    this.remoteproduct_ID = '';
    this.remoteTitle = '';
    this.updateMessage = '';
    this.ecommerceConnection = undefined;
    this.product = undefined;
    this.rawRemoteProduct = '';
    this.ignoreStatus = 'NOT_IGNORE';
    this.remoteTimestamp = new Date(0);
    this.productStatus = 'READY';
    this.updateStatus = '';
    this.changeType = '';
    this.update(obj);
  }

  getId () {
    return this.ID;
  }

  getOrderValue () {
    return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
      }
    }
  }

  /**
   * Enum-backed columns that the database gives a default.
   *
   * The constructor seeds them to `''` so the object has a defined shape, but
   * `''` is not a member of any of these enums. Sending it makes MySQL in
   * non-strict mode silently store a blank, which is where rows with empty
   * statuses come from — the server asked us to omit them instead
   * (`docs/contracts/inbox/2026-09-16-ecommerceproduct-association-guard.md` §4).
   * Omitting lets the column default apply on insert and leaves it untouched on
   * update; a real value is still sent normally.
   */
  private static readonly ENUM_PROPERTIES_OMITTED_WHEN_BLANK = [
    'remoteUpdateStatus',
    'remoteChangeType',
    'updateStatus',
    'changeType'
  ];

  toJSON() {
    const obj = {};
    for (const prop of Object.keys(this)) {
      if (this[prop] !== null && ( typeof this[prop] === 'string' || typeof this[prop] === 'number' || typeof this[prop] === 'boolean' || this[prop] instanceof String || this[prop] instanceof Boolean || this[prop] instanceof Number || this[prop] instanceof Date )) {
        if ( this[prop] === '' && EcommerceProduct.ENUM_PROPERTIES_OMITTED_WHEN_BLANK.indexOf(prop) !== -1 ) {
          continue;
        }
        obj[prop] = this[prop];
      }
    }
    return obj;
  }

}
